import { Link } from "react-router-dom";
import { ArrowUpRight, Compass } from "lucide-react";
import { Reveal } from "./motion";
import { getCity } from "@/data/cities";

export default function EmptyState({
    citySlug,
    category,
    nearby = [],
    compact = false,
}) {
    const city = citySlug ? getCity(citySlug) : null;
    const title = city
        ? `We're currently onboarding verified developers in ${city.name}.`
        : category
          ? `We're currently onboarding verified ${category} developers across India.`
          : "We're currently onboarding verified developers across India.";

    return (
        <Reveal>
            <div
                data-testid="empty-state"
                className={`gold-ring relative overflow-hidden rounded-3xl bg-surface/60 text-center ${
                    compact ? "p-8 sm:p-10" : "p-10 sm:p-16"
                }`}
            >
                <div
                    className="pointer-events-none absolute -top-24 left-1/2 h-64 w-[36rem] -translate-x-1/2 rounded-full opacity-20 blur-3xl"
                    style={{
                        background:
                            "radial-gradient(ellipse, #C96F4A 0%, transparent 65%)",
                    }}
                />
                <div className="relative">
                    <Compass className="mx-auto h-8 w-8 text-gold" strokeWidth={1.25} />
                    <p className="eyebrow mt-6">Curated · Coming Soon</p>
                    <h3 className="mx-auto mt-4 max-w-2xl font-serif text-2xl leading-snug text-ivory sm:text-3xl lg:text-4xl">
                        {title}
                    </h3>
                    <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-mist">
                        Sthaan opens city by city with a small, hand-picked collection of
                        genuine new projects — never a flood of listings. Exceptional
                        showcases are on their way
                        {city ? ` to ${city.name}` : ""}.
                    </p>
                    <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
                        <Link
                            to="/discover"
                            data-testid="empty-state-explore-india"
                            className="inline-flex items-center gap-2 rounded-full bg-gold px-6 py-3 text-sm font-medium text-obsidian transition-colors hover:bg-gold-bright"
                        >
                            Explore projects across India
                            <ArrowUpRight className="h-4 w-4" />
                        </Link>
                        <Link
                            to="/developers"
                            data-testid="empty-state-developer-link"
                            className="link-line text-sm text-mist transition-colors hover:text-gold"
                        >
                            Are you a developer? List with us
                        </Link>
                    </div>
                    {nearby.length > 0 && (
                        <div className="mt-10">
                            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-dim">
                                In the meantime, discover
                            </p>
                            <div className="mt-4 flex flex-wrap justify-center gap-2">
                                {nearby.map((slug) => {
                                    const n = getCity(slug);
                                    if (!n) return null;
                                    return (
                                        <Link
                                            key={slug}
                                            to={`/city/${slug}`}
                                            data-testid={`empty-state-nearby-${slug}`}
                                            className="rounded-full border border-black/10 px-4 py-2 text-xs text-mist transition-colors hover:border-gold/40 hover:text-gold"
                                        >
                                            {n.name}
                                        </Link>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </Reveal>
    );
}
